enum AiSuggestion {
  NotEnoughInfo,
  Verify,
  Deny,
}

export default AiSuggestion
